import { Link, usePage } from '@inertiajs/react'
import { Fragment, type ReactNode } from 'react'
import type { SharedProps } from '../types'

// The public pages, linked from every page that renders the footer. Before
// this the footer only linked the ICP record, /guide/pomodoro had a single
// inbound link (from /pomodoro) and the per-client docs pages were reachable
// only from the docs sidebar.
const LINKS = [
  { href: '/pomodoro', label: '番茄钟' },
  // 博客只在页脚露出，**不进 Header** —— 顶条是登录用户每天干活的地方，
  // 而博客是写给陌生人看的（blog 设计文档 §8）。
  { href: '/blog', label: '博客' },
  { href: '/guide/pomodoro', label: '番茄工作法指南' },
  { href: '/developers', label: '接入文档' },
  { href: '/developers/claude-code', label: 'Claude Code 接入' },
  { href: '/developers/codex', label: 'Codex 接入' },
]

// 三格：版权、备案号、版本号。后两格的值从服务端的共享 props 来（SiteMeta），
// 任一为空就整格连分隔符一起不渲染。
//
// 原来这里读 import.meta.env.VITE_ICP_NUMBER / VITE_VERSION_NUMBER，而那两个
// 变量从来没有人设过 —— Next.js 迁过来时消费者改了名（生产者 bin/deploy.sh
// 至今 export 的还是 NEXT_PUBLIC_*），而且构建从「宿主机上 next build」挪进了
// 镜像，宿主机 export 的变量根本进不去 docker build。于是页脚长期是
// 「© 2026 番茄钟应用 |  | version: 」这个样子，生产也一样。详见 SiteMeta。
export default function Footer() {
  const site = usePage<SharedProps>().props.site

  const segments: { key: string; node: ReactNode }[] = [
    { key: 'copyright', node: <>© {new Date().getFullYear()} asaptodo</> },
  ]

  if (site?.icpNumber) {
    segments.push({
      key: 'icp',
      node: (
        <a
          href="https://beian.miit.gov.cn/"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:underline"
        >
          {site.icpNumber}
        </a>
      ),
    })
  }

  if (site?.version) {
    segments.push({ key: 'version', node: <>version: {site.version}</> })
  }

  return (
    <footer className="border-t border-brand-line p-4 text-center text-sm text-brand-ink3">
      <nav aria-label="站点链接" className="mb-2 flex flex-wrap justify-center gap-x-4 gap-y-1">
        {LINKS.map((link) => (
          <Link key={link.href} href={link.href} className="hover:text-brand-ink hover:underline">
            {link.label}
          </Link>
        ))}
      </nav>
      <div>
        {segments.map(({ key, node }, index) => (
          <Fragment key={key}>
            {index > 0 && <span className="mx-1.5 text-brand-line2">|</span>}
            {node}
          </Fragment>
        ))}
      </div>
    </footer>
  )
}
